import React from "react";
import { connect } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
const PrivateRoute = ({ component: Component, auth, location, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return auth.isLoaded ? (
          auth.isEmpty ? (
            <Redirect to="/login" />
          ) : (
            <Component {...props} />
          )
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

const mapStateToProps = ({ firebase: { auth } }) => ({
  auth
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
